<template>
	<card header-classes="bg-dark">
		<template slot="header">
			<h3 class="mb-0 text-white">ตั้งค่าถอนเงินอัตโนมัติ</h3>
		</template>
		<template>
			<form @submit.prevent="saveSetting">
				<base-input label="ประเภท">
					<el-select v-model="data.type" placeholder="ประเภท">
						<el-option label="SCB API" value="api" />
						<el-option label="SCB Easy Net" value="easynet" />
					</el-select>
				</base-input>
				<base-input label="ยอดถอนสูงสุด" placeholder="ยอดถอนสูงสุด" v-model.number="data.maxAmount" />
				<base-input label="บัญชี">
					<el-select v-model="data.accountNumber" placeholder="บัญชี" v-if="data.type === 'easynet'">
						<el-option
							v-for="v in scbBanks"
							:key="v.accountNumber"
							:label="`${v.accountName} - ${v.accountNumber}`"
							:value="v.accountNumber"
						/>
					</el-select>
					<el-select v-model="data.accountNumber" placeholder="บัญชี" v-if="data.type === 'api'">
						<el-option
							v-for="v in scbAccounts"
							:key="v.accountNumber"
							:label="`${v.accountName} - ${v.accountNumber}`"
							:value="v.accountNumber"
						/>
					</el-select>
				</base-input>
				<base-input
					label="เบอร์โทรศัพท์ 3 ตัวสุดท้าย"
					placeholder="เบอร์โทรศัพท์ 3 ตัวสุดท้าย"
					v-model="data.mobileNo"
					v-if="data.type === 'easynet'"
				/>

				<div class="mt-3">
					<base-checkbox v-model="data.noBonus.enable">
						ถอนเงินอัตโนมัติเมื่อไม่มีรายการรับโบนัส
					</base-checkbox>
					<div class="mt-3">
						<base-input
							label="ยอดถอนสูงสุด (ไม่รับโบนัส)"
							placeholder="ยอดถอนสูงสุด (ไม่รับโบนัส)"
							v-model.number="data.noBonus.maxAmount"
							v-if="data.noBonus.enable"
						/>
					</div>
				</div>

				<div class="mt-3">
					<base-button native-type="submit" type="default" :disabled="loading">
						บันทึกข้อมูล
					</base-button>
				</div>
			</form>
		</template>
	</card>
</template>

<script>
import { Select, Option } from 'element-ui'

import api from '../../services'

export default {
	props: ['withdrawAccount', 'banks', 'scbAccounts'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,
			data: {
				type: null,
				maxAmount: 0,
				accountNumber: null,

				noBonus: {
					enable: false,
					maxAmount: 0,
				},
			},
		}
	},
	computed: {
		scbBanks() {
			return Object.values(this.banks).filter((x) => x.bank === 'scb')
		},
	},
	methods: {
		saveSetting() {
			this.loading = true
			api.post('/setting/website/withdraw-account', this.data)
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	created() {
		this.data = Object.assign({}, this.withdrawAccount)
	},
	watch: {
		withdrawAccount(v) {
			this.data = Object.assign({}, v)
		},
		'data.type'(v, old) {
			if (old && v !== old) {
				this.data.accountNumber = ''
			}
		},
	},
}
</script>
